import React, { useRef, useEffect, useState } from 'react';
import { Text } from 'recharts';

const CustomizedYaxisLabel = ({ name, isLeft, chartWidth, labelY }) => {
  const labelSetup = isLeft
    ? { x: 0, y: labelY, dx: 20, textAnchor: 'start', angle: 270, colour: "#EF5350" }
    : { x: 0, y: labelY, dx: chartWidth === undefined || chartWidth <= 0 ? 1000 : chartWidth - 30, textAnchor: 'end', angle: 90 , colour: "#42A5F5"};

  // Get a reference to the parent container
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // Update container width on component mount and window resize
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const width = containerRef.current.clientWidth;
        setContainerWidth(width);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate dynamic dx value for responsive positioning
  const calculateDx = () => {
    const chartWidthBuffer = 20; // Adjust this value as needed
    const dxOffset = isLeft ? chartWidthBuffer : -chartWidthBuffer;
    return labelSetup.dx + dxOffset;
  };


  return (

    <Text ref={containerRef} style={{ position: 'relative' }}
      x={labelSetup.x}
      y={labelSetup.y}
      dx={labelSetup.dx}
      dy={180}
      textAnchor={labelSetup.textAnchor}
      width={200}
      angle={labelSetup.angle}
      fontSize="18"
      fill={labelSetup.colour}
    >
      {name}
    </Text>

  );

};

export default CustomizedYaxisLabel;
